import React from 'react'
import './GameContainer.css'

const GameWaitData = () => {
    return (
        <div className="game-container">
            <div className="wait-container">
                <p>Loading...</p>
            </div>
        </div>
    )
}

export default GameWaitData
